import { render, staticRenderFns } from "./tree-view-bucket.vue?vue&type=template&id=5451029c"
import script from "./tree-view-bucket.vue?vue&type=script&lang=js"
export * from "./tree-view-bucket.vue?vue&type=script&lang=js"
import style0 from "./tree-view-bucket.vue?vue&type=style&index=0&id=5451029c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports